import React, { useState } from "react";
import { Link } from "react-router-dom";

const AboutTabsContent = ({ steps }) => {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div className="container py-5 step-progress custom-container">
      <div className="step-wrapper d-flex flex-wrap flex-column align-items-center flex-md-row align-items-md-start gap-4">
        <div className="step-buttons">
          {steps.map((step) => (
            <button
              key={step.id}
              className={`step-btn text-start px-20 px-md-38 py-15 ah-text-lg mb-10 ${
                activeStep === step.id ? "active" : ""
              }`}
              onClick={() => setActiveStep(step.id)}
            >
              {step.id}. {step.title}
            </button>
          ))}
        </div>

        <div className="progress-line d-flex align-items-center flex-row flex-md-column justify-content-center justify-content-md-start">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div
                className={`circle-step ${
                  activeStep === step.id ? "active" : ""
                }`}
              ></div>
              {index < steps.length - 1 && <div className="line"></div>}
            </React.Fragment>
          ))}
        </div>

        <div className="step-content">
          <div className="step-pane">
            <h4 className="fw-bold mb-5">{steps[activeStep - 1].title}</h4>
            <p className="ah-text-lg fw-normal mb-50">
              {steps[activeStep - 1].content}
            </p>
            <Link
              to={""}
              className="learn-more ah-text-lg fw-bold text-decoration-none"
            >
              Learn more →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTabsContent;